(() => {
  'use strict';

  // Kör bara en gång per sidladdning
  if (window.__thujorDeliveryWeekInit) return;
  window.__thujorDeliveryWeekInit = true;

  const CONFIG = {
    startDate: new Date(2026, 2, 1),
    endDate: new Date(2026, 10, 15),
    holidays: [
      new Date(2026, 3, 3), new Date(2026, 3, 5), new Date(2026, 3, 6),
      new Date(2026, 4, 1), new Date(2026, 4, 14), new Date(2026, 5, 6),
      new Date(2026, 5, 19), new Date(2026, 5, 20), new Date(2026, 11, 24),
      new Date(2026, 11, 25), new Date(2026, 11, 26), new Date(2026, 11, 31)
    ],
    attr: {
      date: 'delivery_date',
      note: 'delivery_note',
      week: 'delivery_week_number'
    }
  };

  let saveInProgress = false;
  let lastSavedValue = null;

  function setError(msg) {
    const el = document.querySelector('.delivery-week-error');
    if (el) el.textContent = msg || '';
  }

  function getWeekNumber(date) {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
  }

  function formatShortDate(date) {
    const months = ['jan','feb','mars','apr','maj','juni','juli','aug','sep','okt','nov','dec'];
    return `${date.getDate()} ${months[date.getMonth()]}`;
  }

  function formatDateValue(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  function getNextMonday(date) {
    const result = new Date(date);
    const day = result.getDay();
    if (day === 1) return result;
    if (day === 0) result.setDate(result.getDate() + 1);
    else result.setDate(result.getDate() + (8 - day));
    return result;
  }

  function getFriday(monday) {
    const friday = new Date(monday);
    friday.setDate(friday.getDate() + 4);
    return friday;
  }

  function getWeekSpan(monday) {
    const friday = getFriday(monday);
    return `${formatShortDate(monday)}–${formatShortDate(friday)}`;
  }

  function isWeekPassed(monday) {
    const today = new Date();
    today.setHours(0,0,0,0);
    const m = new Date(monday);
    m.setHours(0,0,0,0);
    return m < today;
  }

  function isHolidayWeek(monday) {
    const friday = getFriday(monday);
    return CONFIG.holidays.some(h => {
      const t = h.getTime();
      return t >= monday.getTime() && t <= friday.getTime();
    });
  }

  function populateWeeks() {
    const select = document.getElementById('delivery-week-select');
    if (!select) return;

    const frag = document.createDocumentFragment();
    frag.appendChild(new Option('Välj leveransvecka', '', true, true));
    frag.appendChild(new Option('Så snabbt som möjligt', 'asap'));

    let currentMonday = getNextMonday(CONFIG.startDate);
    let added = 0;

    while (currentMonday <= CONFIG.endDate) {
      if (!isWeekPassed(currentMonday) && !isHolidayWeek(currentMonday)) {
        const weekNum = getWeekNumber(currentMonday);
        const weekSpan = getWeekSpan(currentMonday);
        frag.appendChild(new Option(`Vecka ${weekNum} (${weekSpan})`, formatDateValue(currentMonday)));
        added++;
      }
      currentMonday.setDate(currentMonday.getDate() + 7);
    }

    select.innerHTML = '';
    select.appendChild(frag);


    console.log('[DW] populateWeeks added:', added);
  }

  async function saveAttributesToShopify(attributes) {
    if (saveInProgress) return;
    saveInProgress = true;

    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes })
      });

      if (!res.ok) throw new Error('Cart update failed');
      const data = await res.json();
      console.log('✅ [DW] saved attributes:', data.attributes);
      setError('');
    } catch (e) {
      console.error('❌ [DW] save failed:', e);
      setError('Kunde inte spara leveransvalet. Ladda om sidan och försök igen.');
    } finally {
      saveInProgress = false;
    }
  }

  async function handleSelectValue(selectedValue) {
    lastSavedValue = selectedValue;

    if (!selectedValue) {
      const attrs = {};
      attrs[CONFIG.attr.date] = '';
      attrs[CONFIG.attr.note] = '';
      attrs[CONFIG.attr.week] = '';
      await saveAttributesToShopify(attrs);
      return;
    }

    let date = '';
    let note = '';
    let week = '';

    if (selectedValue === 'asap') {
      date = 'asap';
      note = 'Leverans: Så snabbt som möjligt';
      week = '';
    } else {
      const selectedMonday = new Date(selectedValue + 'T00:00:00');
      const weekNum = getWeekNumber(selectedMonday);
      const weekSpan = getWeekSpan(selectedMonday);
      date = selectedValue;
      note = `Önskad leveransvecka: v${weekNum} (${weekSpan})`;
      week = String(weekNum);
    }

    const attrs = {};
    attrs[CONFIG.attr.date] = date;
    attrs[CONFIG.attr.note] = note;
    attrs[CONFIG.attr.week] = week;

    await saveAttributesToShopify(attrs);
  }

  function bindSelectListeners() {
    // Change (om pluginen triggar change)
    document.addEventListener('change', function(e){
      const t = e.target;
      if (t && t.id === 'delivery-week-select') {
        handleSelectValue(t.value);
      }
    });

    // Click-fallback (semantic select UI)
    document.addEventListener('click', function(e){
      const picker = document.querySelector('[data-delivery-week-picker]');
      if (!picker) return;
      if (!picker.contains(e.target)) return;

      setTimeout(() => {
        const select = document.getElementById('delivery-week-select');
        if (!select) return;

        if (!select.value) return;
        if (select.value === lastSavedValue) return;

        handleSelectValue(select.value);
      }, 80);
    });
  }

  function runInit() {
    if (!document.querySelector('[data-delivery-week-picker]')) return;
    if (!document.getElementById('delivery-week-select')) return;

    populateWeeks();
    bindSelectListeners();

    // Kör igen efter att Xtra hunnit initiera sin select
    setTimeout(populateWeeks, 600);
  }

  document.addEventListener('DOMContentLoaded', runInit);
  document.addEventListener('shopify:section:load', runInit);
    // Övervaka DOM-ändringar i varukorgen för att ladda om veckor
  document.addEventListener('DOMContentLoaded', function() {
    const cartElement = document.querySelector('form[action="/cart"]') || document.querySelector('[data-cart-form]');
    
    if (cartElement) {
      const observer = new MutationObserver(function(mutations) {
        console.log('[DW] Cart DOM changed - reloading weeks');
        const picker = document.querySelector('[data-delivery-week-picker]');
        const select = document.getElementById('delivery-week-select');
        
        if (picker && select) {
          setTimeout(function() {
            populateWeeks();
          }, 300);
        }
      });
      
      observer.observe(cartElement, {
        childList: true,
        subtree: true
      });
      
      console.log('[DW] MutationObserver active - watching cart changes');
    }
  });
})();
